import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
    StockTransferCreateDTO,
    StockTransferDTO,
    StockTransferResponse,
} from '../interfaces/stockTransfer.interface';
import { AuthService } from './auth.service';

export const StockTransferService = {
    getStockTransfersByInstitution: async (
        status: string = '',
        page: number = 0,
        size: number = 10,
    ): Promise<StockTransferResponse> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const statusParam = status ? `&status=${status}` : '';
        const response = await axios.get(
            `${ENDPOINTS.STOCK_TRANSFER.LIST_BY_INSTITUTION(institutionId)}?page=${page}&size=${size}${statusParam}`,
        );
        return response.data;
    },

    getStockTransferById: async (id: string): Promise<StockTransferDTO> => {
        const response = await axios.get(ENDPOINTS.STOCK_TRANSFER.GET_BY_ID(id));
        return response.data;
    },

    createStockTransfer: async (transfer: StockTransferCreateDTO): Promise<StockTransferDTO> => {
        const response = await axios.post(ENDPOINTS.STOCK_TRANSFER.CREATE, transfer);
        return response.data;
    },

    submitStockTransfer: async (id: string): Promise<StockTransferDTO> => {
        const response = await axios.post(ENDPOINTS.STOCK_TRANSFER.SUBMIT(id));
        return response.data;
    },

    approveStockTransfer: async (id: string): Promise<StockTransferDTO> => {
        const response = await axios.post(ENDPOINTS.STOCK_TRANSFER.APPROVE(id));
        return response.data;
    },

    cancelStockTransfer: async (id: string): Promise<StockTransferDTO> => {
        const response = await axios.post(ENDPOINTS.STOCK_TRANSFER.CANCEL(id));
        return response.data;
    },
};
